<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import http from "./common/http";
import api from "./common/constants";
import $ from "jquery";
export default {
  name: "App",
  watch: {
    $route(to, from) {
      document.title = this.$route.meta.title || this.$route.name;
    },
  },
  created(){
    
  },
  mounted(){
    // this.tto()
  },
    methods:{
     
        }
};
</script>

<style>
* {
  font-family: "Avenir", SourceHanSansCN-Regular, SourceHanSansCNHelvetica, Arial, sans-serif ;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  color: #2c3e50;
  /*margin-top: 60px;*/
}
body,
div,
p {
  margin: 0;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue